import React from 'react';
import { SearchIcon } from 'lucide-react';
interface ProjectFiltersProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  sectorFilter: string;
  setSectorFilter: (s: string) => void;
  statusFilter: string;
  setStatusFilter: (s: string) => void;
  sectors: string[];
}
export function ProjectFilters({
  searchQuery,
  setSearchQuery,
  sectorFilter,
  setSectorFilter,
  statusFilter,
  setStatusFilter,
  sectors
}: ProjectFiltersProps) {
  return <div className="bg-white rounded-lg border border-gray-border p-6 mb-8" data-id="element-369">
      <div className="grid md:grid-cols-3 gap-4" data-id="element-370">
        <div data-id="element-371">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-372">
            Search
          </label>
          <div className="relative" data-id="element-373">
            <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-374" />
            <input type="text" placeholder="Search projects..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-375" />
          </div>
        </div>

        <div data-id="element-376">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-377">
            Sector
          </label>
          <select value={sectorFilter} onChange={e => setSectorFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-378">
            <option value="All Sectors" data-id="element-379">All Sectors</option>
            {sectors.map(s => <option key={s} value={s} data-id="element-380">
                {s}
              </option>)}
          </select>
        </div>

        <div data-id="element-381">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-382">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-383">
            <option value="all" data-id="element-384">All Status</option>
            <option value="active" data-id="element-385">Active</option>
            <option value="completed" data-id="element-386">Completed</option>
          </select>
        </div>
      </div>
    </div>;
}